// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.collapsible-bottom-bar {
  pointer-events: none;
  z-index: 2;
  background: none;
  height: 300px;
  margin-bottom: -300px;
  transition: margin-bottom .3s;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: auto;
}

.collapsible-bottom-bar--open {
  margin-bottom: 0;
}

.collapsible-bottom-bar__header {
  pointer-events: none;
}

.collapsible-bottom-bar__wrapper {
  margin-top: 12px;
}

.collapsible-bottom-bar__content {
  background: #fff;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/CollapsibleBottomBar/CollapsibleBottomBar.css","webpack://./services/frontend/app/components/CollapsibleBottomBar/CollapsibleBottomBar.css"],"names":[],"mappings":"AADA;ECEE,oBAAoB;EACpB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,6BAA6B;EAC7B,SAAS;EACT,OAAO;EACP,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".collapsible-bottom-bar {\n  background: none;\n  bottom: 0;\n  margin-bottom: -300px;\n  height: 300px;\n  left: 0;\n  overflow: auto;\n  pointer-events: none;\n  right: 0;\n  transition: margin-bottom 0.3s ease;\n  z-index: 2;\n}\n\n.collapsible-bottom-bar--open {\n  margin-bottom: 0;\n}\n\n.collapsible-bottom-bar__header {\n  pointer-events: none;\n}\n\n.collapsible-bottom-bar__wrapper {\n  margin-top: 12px;\n}\n\n.collapsible-bottom-bar__content {\n  background: #fff;\n}\n",".collapsible-bottom-bar {\n  pointer-events: none;\n  z-index: 2;\n  background: none;\n  height: 300px;\n  margin-bottom: -300px;\n  transition: margin-bottom .3s;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  overflow: auto;\n}\n\n.collapsible-bottom-bar--open {\n  margin-bottom: 0;\n}\n\n.collapsible-bottom-bar__header {\n  pointer-events: none;\n}\n\n.collapsible-bottom-bar__wrapper {\n  margin-top: 12px;\n}\n\n.collapsible-bottom-bar__content {\n  background: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
